import React from 'react';
import { Link } from 'react-scroll';
//import { Button } from '../../button/Button'
import './Header.scss';

const Header = () => {

    return (
        <div className="Header" >
            {/* <div className="header-title">Wilderness within reach</div> */}
            <div className="header-content-section">
                <div className="header-content-section-left" >
                    <div className="header-content-section-logo-container">
                        <img className="header-content-section-logo" src="/images/logo/logo1.png" alt="logo" />
                    </div>
                    <div className="header-content-logo-title text-center" >
                        LEO CLUB OF COLOMBO MONARCH
                    </div>
                    <div className="header-content-logo-sub-title" >
                        District 306 A2, Sri Lanka
                    </div>
                    <div className="header-content-description" >
                        Leo Club of Colombo Monarch was formed in July,
                        2021 in the Leo District 306 A2 and we are sponsored
                        by Lions Club of Dehiwala North. We aim to enable the
                        young generation to identify and address the community
                        needs, so we can make this a platform to develop their
                        skills as future leaders in the country. We welcome
                        you all to join your hands with us to reimagine the
                        humanity and serve the community.
                    </div>
                </div>
                <div className="header-content-nav-btn-section" >
                    <Link
                        to="about-us"
                        smooth={false}
                        offset={0}
                        duration={500}
                        delay={0}
                        spy={true}>
                        <div className="header-content-nav-btn">{'About Us'}</div>
                    </Link>

                    <Link
                        to="our-projects"
                        smooth={false}
                        offset={0}
                        duration={500}
                        delay={0}
                        spy={true}>
                        <div className="header-content-nav-btn">{'Our Projects'}</div>
                    </Link>

                    <Link
                        to="contact-us"
                        smooth={false}
                        offset={0}
                        duration={500}
                        delay={0}
                        spy={true}>
                        <div className="header-content-nav-btn">{'Contact Us'}</div>
                    </Link>

                    <Link
                        to="join-us"
                        smooth={false}
                        offset={0}
                        duration={500}
                        delay={0}
                        spy={true}>
                        <div className="header-content-nav-btn special">{'Join Us '}</div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Header;
